import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createAcademy, getAcademies, getAcademyById, getWdcSports, updateAcademy, updateAcademyStatus,
} from '../../axios/academiesRequests';
import {
  uploadFileURL,
} from '../../axios/requests';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  uploadFile,
} from '../../helperFunctions/uploadService';
import {
  IAcademiesStore,
} from '../storeInterfaces/academiesInterface';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import { RequestStatus } from 'mobx-store';

export class AcademiesStore implements IAcademiesStore {
  @observable academiesList: any[] = [];

  @observable wdcSportsList: any[] = [];

  @observable selectedAcademy = {
  };

  @observable loading = false;
  @observable getAcademiesRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getAcademies(countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      this.getAcademiesRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);
      const response = await Connections.wadiDeglaAxios.httpGet(`${getAcademies(availableCountries)}`, getHeader(langCode));
      this.academiesList = this.restructureAcademiesList(response.data);
      this.getAcademiesRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getAcademiesRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getSportsWDC(langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getWdcSports, getHeader(langCode));
      this.wdcSportsList = response.data;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async filterAcademies(query: string, countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      const countriesIsoCode = countries.map((country: ICountry) => country.isoCode);
      const availableCountries = countriesIsoCode.toString();

      const config = {
        ...getHeader(langCode),
        params: {
          query,
        },
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getAcademies(availableCountries), config);
      this.academiesList = this.restructureAcademiesList(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getAcademyById(id: number, langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getAcademyById(id), getHeader(langCode));
      this.selectedAcademy = this.restructureAcademy(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createAcademy(newAcademy: any, langCode: string = DefaultLanguage): Promise<any> {
    return new Promise<void>(async (res, rej) => {
      try {
        const images = await this.uploadAcademyImages(newAcademy.images);
        const cardThumbnailImage = await this.uploadSingleImage(newAcademy.cardThumbnail);
        console.log(cardThumbnailImage);
        const backgroundThumbnailImage = await this.uploadSingleImage(newAcademy.backgroundThumbnail);
        newAcademy.images = images;
        newAcademy.cardThumbnail = cardThumbnailImage;
        newAcademy.backgroundThumbnail = backgroundThumbnailImage;
        const response = await Connections.wadiDeglaAxios.httpPost(createAcademy, this.restructureCreateAcademy(newAcademy), getHeader(langCode));
        res(response.data.academyId);
        // return
      } catch (error) {
        rej();
      } finally {

      }
    });
  }

  @action.bound
  public async updateAcademy(updatedAcademy: any, academyId: number, initGallery: {imageUrl: string; key: number}[],
    langCode: string = DefaultLanguage): Promise<any> {
    try {
      const deletedImagesIds: number[] = [];
      const newImages: any[] = [];
      for (const image of updatedAcademy.images) {
        if (image.preview) {
          newImages.push(image);
        } else {
          const findIndex = initGallery.findIndex((media) => media.key === image.key);
          if (findIndex !== -1) {
            initGallery.splice(findIndex, 1);
          }
        }
      }
      for (const image of initGallery) {
        deletedImagesIds.push(image.key);
      }
      const uploadedImages = await this.uploadAcademyImages(newImages);
      const cardThumbnailImage = await this.uploadSingleImage(updatedAcademy.cardThumbnail);
      const backgroundThumbnailImage = await this.uploadSingleImage(updatedAcademy.backgroundThumbnail);
      updatedAcademy.newImages = uploadedImages;
      updatedAcademy.deletedImagesIds = deletedImagesIds;
      updatedAcademy.cardThumbnail = cardThumbnailImage;
      updatedAcademy.backgroundThumbnail = backgroundThumbnailImage;
      await Connections.wadiDeglaAxios.httpPut(updateAcademy(academyId),
        this.restructureUpdateAcademy(updatedAcademy), getHeader(langCode));
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound
  public async updateAcademyStatus(updatedAcademyStatus: boolean, index: number): Promise<any> {
    try {
      await Connections.wadiDeglaAxios.httpPut(updateAcademyStatus(this.academiesList[index].academyId), {
        isActive: updatedAcademyStatus,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.academiesList[index].isActive = updatedAcademyStatus;
    }
  }

  private restructureAcademiesList(academies: any[]): any[] {
    const academiesList = [];
    for (const academy of academies) {
      academiesList.push({
        academyId: academy.academyId,
        title: academy.title,
        isActive: academy.isActive,
      });
    }
    return academiesList.map((academy) => ({
      ...academy, edit: 'Edit',
    }));
  }

  private uploadAcademyImages(images: any[]) {
    const promises = [];
    const allImages: any[] = [];
    for (const image of images) {
      if (image.preview) {
        promises.push(
          uploadFile(uploadFileURL, image)
            .then((res: any) => {
              allImages.push(res.data.downloadURL);
            }),
        );
      } else {
        allImages.push(image.imageUrl);
      }
    }
    return Promise.all(promises)
      .then(() => {
        console.log('done');
        return allImages;
      }).catch((error) => {
        console.log('error');
        return allImages;
      });
  }

  private uploadSingleImage(images: any[]) {
    const promises = [];
    const allImages: any[] = [];
    for (const image of images) {
      if (image.preview) {
        promises.push(
          uploadFile(uploadFileURL, image)
            .then((res: any) => {
              allImages.push(res.data.downloadURL);
            }),
        );
      } else {
        allImages.push(image.imageUrl);
      }
    }
    return Promise.all(promises)
      .then(() => {
        console.log('done');
        return (allImages.length ? allImages[0] : null);
      }).catch((error) => {
        console.log('error');
        return (allImages.length ? allImages[0] : null);
      });
  }

  private restructureAcademy(academy: any): any {
    return {
      academyId: academy.academyId,
      images: (academy.academyImages && academy.academyImages.length
        ? academy.academyImages.map((image: any, index: number) => ({
          imageUrl: image.imageURL, key: image.academyImageId,
        })) : []),
      cardThumbnail: (academy.previewCardImageURL ? [{
        imageUrl: academy.previewCardImageURL,
      }] : []),
      backgroundThumbnail: (academy.detailsPageBackgroundImageURL ? [{
        imageUrl: academy.detailsPageBackgroundImageURL,
      }] : []),
      isActive: academy.isActive,
      title: academy.title,
      description: academy.description,
      availableBranches: (academy.branches && academy.branches
        ? academy.branches.map((branch: any) => (branch.branchId)) : []),
      AcademyCategories: (academy.categories && academy.categories
        ? academy.categories.map((category: any) => (category.articleCategoryId)) : []),
      SportsWDC: academy.wdcAcademyId,
    };
  }

  private restructureCreateAcademy(academy: any): any {
    return {
      title: academy.title,
      description: academy.description,
      isActive: academy.isActive,
      images: academy.images,
      availableBranchesIds: academy.availableBranches,
      previewCardImageURL: academy.cardThumbnail,
      detailsPageBackgroundImageURL: academy.backgroundThumbnail,
      categoriesIds: academy.AcademyCategories,
      wdcAcademyId: academy.SportsWDC,
      availableCountries: academy.availableCountries,
    };
  }

  private restructureUpdateAcademy(academy: any): any {
    return {
      title: academy.title,
      description: academy.description,
      isActive: academy.isActive,
      newImages: academy.newImages,
      deletedImagesIds: academy.deletedImagesIds,
      availableBranchesIds: academy.availableBranches,
      previewCardImageURL: academy.cardThumbnail,
      detailsPageBackgroundImageURL: academy.backgroundThumbnail,
      categoriesIds: academy.AcademyCategories,
      wdcAcademyId: academy.SportsWDC,
    };
  }
}
